import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { assert } from "@/common/assert";
import { VoidUrl } from "@/common/types";
import { cmsHomeUrl } from "@/urls";
export default function ChatBoxHeader(props) {
  assert(props.currentContact, "props.currentContact is falsy");
  var companyInfo = null;

  if (props.currentContact && props.currentContact.user) {
    if (props.currentContact.user.User.Company) {
      var company = props.currentContact.user.User.Company;
      var profession = props.currentContact.user.User.User.Profession;
      companyInfo = _jsxs("p", {
        children: [_jsx("span", __assign({
          className: "chat-box__main-header-profession"
        }, {
          children: profession
        }), void 0), _jsx("a", __assign({
          href: company.NoShops ? VoidUrl : cmsHomeUrl(company.CompanyId),
          className: "js-no-shop chat-box__main-header-company-name",
          "data-companyid": company.CompanyId,
          target: "_blank"
        }, {
          children: company.CompanyName
        }), void 0)]
      }, void 0);
    }
  }

  var info = props.currentContact.getContactInfo();
  return _jsxs("div", __assign({
    className: "chat-box__main-header"
  }, {
    children: [_jsx("p", {
      children: _jsx("a", __assign({
        className: "chat-box__main-title",
        href: info.linkUrl,
        target: "_blank"
      }, {
        children: info.name
      }), void 0)
    }, void 0), companyInfo]
  }), void 0);
}